export const PAGE_VISIT_ENABLED_APPLICATION_IDS = new Set<string>([
  // page_visit 사용중인 고객사
  "6912c9f8aedcac16fcfc0a7d", // 다이소-Prod
  "6912c9e0aedcac16fcfc0a79", // 다이소-Dev
  "691be9f7c7de9faa362d8c48", // 카시나-Prod
  "691ac349e78ecc2d5a37a4bd", // 카시나-Dev
  "68f9902a9aafb67023a93025", // 딜팡
  "691145d1d292a899c62682e4", // 아로마티카
  "693a19d89668decbf9fa40eb", // 익스트림
  "68bfa5d463691efd06a334f7", // 밸런스온
  "694b9e7d1ac816de1506f749", // 닥터펠리스
  "685013d60511e2e7f6e9630b", // 브라이튼몰
  "68cb81450567d160dae8fee5", // 클라뷰
  "68b13865d6f762f9e0b4bc46", // 드리미
  "685013c30511e2e7f6e96307", // 뷰플샵
  // page_visit 사용 아니지만 사용량이 낮아 일단 유지
  "682a8a81cda98b89763fc49a", // 헤이홈
  "683cfe1e35c9c6bf19f17dad", // 조선몰
  "68a628b57b94c993fab57cad", // 뉴트리시아
  "672215128314d291f6e4dce4", // 진로토닉몰
  "683cfe2f35c9c6bf19f17db1", // 헌터
  "6997f09d7f77c0250ca48afd", // 프란츠
  "686b5e22811bbd0d6495306e", // 슬리피솔
  "692ebb4fa9b3001c0badf104", // 프롬바이오
  "69bcb2c7eb118d801417d56d", // 아가드
  "69c07992d2bcd8a97ea4188e", // 베이비스탠다드
  "696496c68b8304cb53350dd3", // 브랜디-Prod
  "6964c0f5d99413ffbfbf82bd", // 브랜디-Dev
  // pm 확인 필요
  "6878af275ead5a75abbdacd7", // 하고하우스-Prod
  "68f5b7be57938849a8bcae47", // 하고하우스-Dev
  "69aac74e3ac14d71405779c6", // 머스트잇-Prod
  "69aac76a7b37b61ed9fdae45", // 머스트잇-Dev
  "696496d28b8304cb53350dd9", // 하이버-Prod
  "6964c0ead99413ffbfbf82b7", // 하이버-Dev
]);
